import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "../../../../../constants/UserRoles";

const breadcrumbStatic = [{
	name: 'Time Tracking',
	url: '/timetracking/self',
	icon: 'clipboard'
}];

export default class Time_Tracking_Self extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history, roles, user} = this.props;
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>
				<div className={"row"}>
					<div className={"col"}>
						<Collections.DispatcherSelfTime
							history={history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							showCSV={roles.includes(UserRoles.Admin)}
							user={user}
						/>
					</div>
				</div>
			</div>
		)
	}
}
